module.exports = __webpack_public_path__ + "static/img/policy-info-gray.a802859a.svg";